$(document).ready(function () {
  $("#sub-metering").hide();

  $(".accordion-tile-one__inner-container").hide();
  $(".accordion-tile-two__inner-container").hide();
  $(".accordion-tile-three__inner-container").hide();
  $(".AccordionSection--desktop__tile__description").show();
  $(".accordion-tile-one").removeClass(
    "AccordionSection__accordion-tile--closed"
  );
  $(".accordion-tile-one").addClass("AccordionSection__accordion-tile--open chart-container");
  $(".accordion-tile-one__inner-container").show();
  $(".accordion-tile-one__inner-container").addClass("chart-inner-container");

  $(".accordion-tile-one__title").removeClass(
    "AccordionSection__accordion-tile__title--closed"
  );

  $(".desktop-accordion-image-container-two").hide();
  $(".desktop-accordion-image-container-three").hide();
  $(".desktop-accordion-tile-one").addClass(
    "AccordionSection--desktop__tile--open"
  );
  $(".desktop-accordion-tile-one__description").show();
  $(".desktop-accordion-tile-one__title").addClass(
    "AccordionSection--desktop__tile__title--open"
  );
  $(".desktop-accordion-tile-two__description").hide();
  $(".desktop-accordion-tile-three__description").hide();

  $("#left-button").click(() => {
    $("#car-chargers").fadeIn();
    $("#sub-metering").fadeOut();
    $("#left-button").addClass("active-button");
    $("#right-button").removeClass("active-button");
  });

  $("#right-button").click(() => {
    $("#car-chargers").fadeOut();
    $("#sub-metering").fadeIn();
    $("#right-button").addClass("active-button");
    $("#left-button").removeClass("active-button");
  });

  // ***** Mobile Accordion ***** //

  $(".accordion-tile-one").click(() => {
    $(".accordion-tile-one").removeClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-one").addClass("AccordionSection__accordion-tile--open chart-container");
    $(".accordion-tile-one__inner-container").addClass("chart-inner-container");
    $(".accordion-tile-one__inner-container").show();

    $(".accordion-tile-one__title").removeClass(
      "AccordionSection__accordion-tile__title--closed"
    );
    $(".accordion-tile-two__title").addClass(
      "AccordionSection__accordion-tile__title--closed"
    );
    $(".accordion-tile-three__title").addClass(
      "AccordionSection__accordion-tile__title--closed"
    );

    $(".accordion-tile-two").removeClass(
      "AccordionSection__accordion-tile--open"
    );
    $(".accordion-tile-three").removeClass(
      "AccordionSection__accordion-tile--open"
    );
    $(".accordion-tile-two").addClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-three").addClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-two__inner-container").hide();
    $(".accordion-tile-three__inner-container").hide();
  });

  $(".accordion-tile-two").click(() => {
    $(".accordion-tile-two").removeClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-two").addClass("AccordionSection__accordion-tile--open");
    $(".accordion-tile-two__inner-container").show();
    $(".accordion-tile-one").removeClass(
      "AccordionSection__accordion-tile--open chart-container"
    );

    $(".accordion-tile-two__title").removeClass(
      "AccordionSection__accordion-tile__title--closed"
    );
    $(".accordion-tile-one__title").addClass(
      "AccordionSection__accordion-tile__title--closed"
    );
    $(".accordion-tile-three__title").addClass(
      "AccordionSection__accordion-tile__title--closed"
    );

    $(".accordion-tile-three").removeClass(
      "AccordionSection__accordion-tile--open"
    );

    $(".accordion-tile-one").addClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-three").addClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-one__inner-container").hide();
    $(".accordion-tile-three__inner-container").hide();
  });

  $(".accordion-tile-three").click(() => {
    $(".accordion-tile-three").removeClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-three").addClass(
      "AccordionSection__accordion-tile--open"
    );
    $(".accordion-tile-three__inner-container").show();

    $(".accordion-tile-three__title").removeClass(
      "AccordionSection__accordion-tile__title--closed"
    );
    $(".accordion-tile-one__title").addClass(
      "AccordionSection__accordion-tile__title--closed"
    );
    $(".accordion-tile-two__title").addClass(
      "AccordionSection__accordion-tile__title--closed"
    );

    $(".accordion-tile-two").removeClass(
      "AccordionSection__accordion-tile--open"
    );
    $(".accordion-tile-one").removeClass(
      "AccordionSection__accordion-tile--open chart-container"
    );

    $(".accordion-tile-one").addClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-two").addClass(
      "AccordionSection__accordion-tile--closed"
    );
    $(".accordion-tile-one__inner-container").hide();
    $(".accordion-tile-two__inner-container").hide();
  });

  // ***** Desktop Accordion ***** //

  $(".desktop-accordion-tile-one").click(() => {
    $(".desktop-accordion-image-container-one").show();
    $(".desktop-accordion-image-container-two").hide();
    $(".desktop-accordion-image-container-three").hide();

    $(".desktop-accordion-tile-one").addClass(
      "AccordionSection--desktop__tile--open"
    );

    $(".desktop-accordion-tile-two").removeClass(
      "AccordionSection--desktop__tile--open"
    );
    $(".desktop-accordion-tile-three").removeClass(
      "AccordionSection--desktop__tile--open"
    );

    $(".desktop-accordion-tile-one__description").show();
    $(".desktop-accordion-tile-two__description").hide();
    $(".desktop-accordion-tile-three__description").hide();

    $(".desktop-accordion-tile-one__title").addClass(
      "AccordionSection--desktop__tile__title--open"
    );
    $(".desktop-accordion-tile-two__title").removeClass(
      "AccordionSection--desktop__tile__title--open"
    );
    $(".desktop-accordion-tile-three__title").removeClass(
      "AccordionSection--desktop__tile__title--open"
    );
  });

  $(".desktop-accordion-tile-two").click(() => {
    $(".desktop-accordion-image-container-one").hide();
    $(".desktop-accordion-image-container-two").show();
    $(".desktop-accordion-image-container-three").hide();

    $(".desktop-accordion-tile-two").addClass(
      "AccordionSection--desktop__tile--open"
    );

    $(".desktop-accordion-tile-one").removeClass(
      "AccordionSection--desktop__tile--open"
    );
    $(".desktop-accordion-tile-three").removeClass(
      "AccordionSection--desktop__tile--open"
    );

    $(".desktop-accordion-tile-one__description").hide();
    $(".desktop-accordion-tile-two__description").show();
    $(".desktop-accordion-tile-three__description").hide();

    $(".desktop-accordion-tile-one__title").removeClass(
      "AccordionSection--desktop__tile__title--open"
    );
    $(".desktop-accordion-tile-two__title").addClass(
      "AccordionSection--desktop__tile__title--open"
    );
    $(".desktop-accordion-tile-three__title").removeClass(
      "AccordionSection--desktop__tile__title--open"
    );
  });

  $(".desktop-accordion-tile-three").click(() => {
    $(".desktop-accordion-image-container-one").hide();
    $(".desktop-accordion-image-container-two").hide();
    $(".desktop-accordion-image-container-three").show();

    $(".desktop-accordion-tile-three").addClass(
      "AccordionSection--desktop__tile--open"
    );

    $(".desktop-accordion-tile-two").removeClass(
      "AccordionSection--desktop__tile--open"
    );
    $(".desktop-accordion-tile-one").removeClass(
      "AccordionSection--desktop__tile--open"
    );

    $(".desktop-accordion-tile-one__description").hide();
    $(".desktop-accordion-tile-two__description").hide();
    $(".desktop-accordion-tile-three__description").show();

    $(".desktop-accordion-tile-one__title").removeClass(
      "AccordionSection--desktop__tile__title--open"
    );
    $(".desktop-accordion-tile-two__title").removeClass(
      "AccordionSection--desktop__tile__title--open"
    );
    $(".desktop-accordion-tile-three__title").addClass(
      "AccordionSection--desktop__tile__title--open"
    );
  });

  ("use strict");

  function _instanceof(left, right) {
    if (
      right != null &&
      typeof Symbol !== "undefined" &&
      right[Symbol.hasInstance]
    ) {
      return !!right[Symbol.hasInstance](left);
    } else {
      return left instanceof right;
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }

  var TestimonialView = function TestimonialView() {
    var _this2 = this;

    _classCallCheck(this, TestimonialView);

    _defineProperty(this, "slideHeight", function (index) {
      return _this2.slideList.height(
        _this2.slideList.children("div[data-position='" + index + "']").height()
      );
    });

    _defineProperty(this, "slideWidth", function () {
      _this2.slideList.width(
        _this2.slideList.parent().width() * _this2.slideList.children().length
      );

      return _this2.slideList
        .children()
        .width(_this2.slideList.parent().width());
    });

    _defineProperty(this, "slideAnim", function (index) {
      return _this2.slideList.css({
        "margin-left": -index * _this2.slideList.parent().width(),
      });
    });

    _defineProperty(this, "slideRotate", function (index) {
      _this2.slideList.children().removeClass("active");

      _this2.pageList.children().removeClass("active");

      _this2.slideList
        .children("div[data-position='" + index + "']")
        .addClass("active");

      _this2.pageList
        .children("a[data-position='" + index + "']")
        .addClass("active");

      return _this2.slideAnim(index);
    });

    _defineProperty(this, "paginate", function (event, index) {
      if (event == null) {
        event = false;
      }

      if (index == null) {
        index = false;
      }

      if (event) {
        event.preventDefault();
      }

      if ($(event.currentTarget).hasClass("active") && !index) {
        return;
      }

      if (event && !index) {
        index = $(event.currentTarget).attr("data-position");
      }

      _this2.slideRotate(index);

      return _this2.slideHeight(index);
    });

    _defineProperty(this, "navigate", function (event) {
      var $navigation, index;

      if (event) {
        event.preventDefault();
      }

      $navigation = $(event.currentTarget).parent("div");

      if ($navigation.hasClass("next-slide")) {
        if (!_this2.slideList.children(".active").next().hasClass("cloned")) {
          index = _this2.slideList
            .children(".active")
            .next()
            .attr("data-position");
        } else {
          index = 1;
        }
      }

      if ($navigation.hasClass("previous-slide")) {
        if (!_this2.slideList.children(".active").prev().hasClass("cloned")) {
          index = _this2.slideList
            .children(".active")
            .prev()
            .attr("data-position");
        } else {
          index = _this2.slideList.children().length - 2;
        }
      }

      _this2.slideRotate(index);

      return _this2.slideHeight(index);
    });

    _defineProperty(this, "prepareRemove", function () {
      _this2.$navigationItem.off("mouseout.testimonials");

      return _this2.$window.off("resize.testimonials");
    });

    var count, slide;
    this.slideList = $(".home-testimonials-slides-list");
    this.pageList = $(".home-testimonials-pagination-list");
    this.$window = $(window);
    this.$navigationItem = $(".home-testimonials-navigation-item a");
    slide = this.slideList.children();
    count = this.slideList.children().length;

    if (count > 1) {
      slide
        .last()
        .clone()
        .removeAttr("data-position")
        .addClass("cloned")
        .prependTo(this.slideList);
      slide
        .first()
        .clone()
        .removeAttr("data-position")
        .addClass("cloned")
        .appendTo(this.slideList);
    } else {
      this.slideList.parents(".home-testimonials").addClass("static");
    }

    this.slideHeight(1);
    this.slideWidth();

    if (count > 1) {
      this.slideRotate(1);
    }

    this.slideList.parents(".home-testimonials").addClass("ready");
    this.$window.on(
      "resize.testimonials",
      (function (_this) {
        return function () {
          var index;
          index = _this.slideList.children(".active").attr("data-position");

          _this.slideHeight(index);

          _this.slideWidth();

          if (count > 1) {
            return _this.slideAnim(index);
          }
        };
      })(this)
    );
    this.$navigationItem.on(
      "mouseout.testimonials",
      (function (_this) {
        return function (event) {
          return $(event.currentTarget).blur();
        };
      })(this)
    );
    $(".home-testimonials-pagination-list-item").click(this.paginate);
    $(".home-testimonials-navigation-item a").click(this.navigate);
  };

  new TestimonialView();
});
